import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    tableLoading: false,
    viewContainerLoading: false,
    showViewContainer: false,
    searchQuery: "",
    currentPage: 1,
    perPage: 5,
    exemptionTotal: null,
    employees: [],
    exemptionsData: [],
    currentExemption: {},
    filterValue: null,
    filterDate: null,
    employeeExemption: [],
    approvals: [],
    currentApproval: {},
    exemptionApproval: [],
    exemptionApprovalTotal: null,
  },
  actions,
  mutations,
};
